import { render, staticRenderFns } from "./PromotionProductBundleSetting.vue?vue&type=template&id=7187f285&"
import script from "./PromotionProductBundleSetting.vue?vue&type=script&lang=js&"
export * from "./PromotionProductBundleSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports